module.exports = __webpack_public_path__ + "img/myazgo2019@2x.0d7dd625.png";